import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import StatementSection from "./components/StatementSection";
import HowItWorks from "./components/HowItWorks";
import Lifecycle from "./components/Lifecycle";
import Screens from "./components/Screens";
import Perimeter from "./components/Perimeter";
import Roadmap from "./components/Roadmap";
import Faq from "./components/Faq";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import useReveal from "./hooks/useReveal";
import { statements } from "./mock/inferraData";

function App() {
  useReveal([]);
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <StatementSection data={statements.savings} />
        <HowItWorks />
        <Lifecycle />
        <StatementSection data={statements.existential} />
        <Screens />
        <Perimeter />
        <Roadmap />
        <Faq />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
